import {
    EuiBasicTable,
    EuiButton,
    EuiButtonIcon,
    EuiModal,
    EuiModalBody,
    EuiModalFooter,
    EuiModalHeader,
    EuiModalHeaderTitle,
    EuiSpacer,
    EuiText,
    EuiTextArea,
} from "@elastic/eui";
import React from "react";

import {
    useDeleteShopGroupMutation,
    useShopGroupsQuery,
    useUpdateShopGroupMutation,
} from "../../api/react-query/queries/admin-page";
import ConfirmationDialog from "../../components/modals/ConfirmationDialog";
import { Shop, ShopGroup } from "../../utils/types";

//TODO Viggo Make actions a separate component similar to the one in the KindsList

const parseShopIds = (shopIds: string) => {
    return shopIds
        .split(/[\s,]+/)
        .map((shopId) => shopId.trim())
        .filter(Boolean);
};

const ShopGroupList = () => {
    const { shopGroups } = useShopGroupsQuery();
    const [confirmDialogOpen, setConfirmDialogOpen] = React.useState(false);
    const [deleteItem, setDeleteItem] = React.useState("");
    const [editModalOpen, setEditModalOpen] = React.useState(false);
    const [editItem, setEditItem] = React.useState<ShopGroup | null>(null);
    const [editShopIds, setEditShopIds] = React.useState("");
    const { mutate: deleteShopGroup } = useDeleteShopGroupMutation();
    const { mutateAsync: updateShopGroup } = useUpdateShopGroupMutation();

    const handleDelete = (id: string) => {
        setDeleteItem(id);
        setConfirmDialogOpen(true);
    };

    const handleEdit = (shopGroup: ShopGroup) => {
        setEditItem(shopGroup);
        setEditShopIds(shopGroup.shops.map((shop) => shop.id).join(","));
        setEditModalOpen(true);
    };

    const handleEditSubmit = async () => {
        if (!editItem) {
            return;
        }

        try {
            await updateShopGroup({
                id: editItem.id,
                name: editItem.name,
                shop_ids: parseShopIds(editShopIds),
            });
            setEditModalOpen(false);
            setEditItem(null);
            setEditShopIds("");
        } catch (error) {
            const updateError = error as any;
            alert(updateError?.response?.data?.detail || updateError?.message || "An error occurred");
        }
    };

    const columns = [
        {
            field: "name",
            name: "Name",
            sortable: true,
            width: "300px",
        },
        {
            field: "shops",
            name: "Shops",
            sortable: true,
            render: (shops: Shop[]) => {
                return shops.map((shop) => shop.name).join(", ");
            },
        },
        {
            width: "100px",
            name: "Actions",
            field: "id",
            render: (id: string, shopGroup: ShopGroup) => {
                return (
                    <div>
                        <EuiButtonIcon
                            aria-label={`Edit ${shopGroup.name}`}
                            iconType="pencil"
                            onClick={() => handleEdit(shopGroup)}
                        />
                        <EuiSpacer size="m" />
                        <EuiButtonIcon
                            aria-label={`Delete ${shopGroup.name}`}
                            onClick={() => handleDelete(id)}
                            iconType="trash"
                        />
                    </div>
                );
            },
        },
    ];

    return (
        <>
            <EuiBasicTable items={shopGroups} columns={columns} itemId="id" />
            <ConfirmationDialog
                isOpen={confirmDialogOpen}
                cancel={() => setConfirmDialogOpen(false)}
                confirm={() => {
                    deleteShopGroup(deleteItem);
                    setConfirmDialogOpen(false);
                }}
                question={"Weet je zeker dat je deze wilt wissen?"}
            />
            {editModalOpen && (
                <EuiModal
                    onClose={() => {
                        setEditModalOpen(false);
                        setEditItem(null);
                        setEditShopIds("");
                    }}
                >
                    <EuiModalHeader>
                        <EuiModalHeaderTitle>Shop IDs bewerken</EuiModalHeaderTitle>
                    </EuiModalHeader>
                    <EuiModalBody>
                        <EuiText>{editItem?.name}</EuiText>
                        <EuiSpacer size="m" />
                        <EuiText>Shop ID&apos;s</EuiText>
                        <EuiTextArea
                            value={editShopIds}
                            onChange={(e) => setEditShopIds(e.target.value)}
                            placeholder="Enter shop id's. Example: ddd70853-5e9d-45ff-82b3-24c9d81d4e32,bbc0cfa7-e230-4338-817a-55190debdac0"
                        />
                    </EuiModalBody>
                    <EuiModalFooter>
                        <EuiButton onClick={handleEditSubmit} fill>
                            Save
                        </EuiButton>
                        <EuiButton
                            onClick={() => {
                                setEditModalOpen(false);
                                setEditItem(null);
                                setEditShopIds("");
                            }}
                        >
                            Cancel
                        </EuiButton>
                    </EuiModalFooter>
                </EuiModal>
            )}
        </>
    );
};

export default ShopGroupList;
